import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
// import { Eye } from "phosphor-react";
import { UserContext } from "context/user";
import "./index.scss";

const BookingStatusCell = ({ value }) => {
  const history = useHistory();
  const { token } = useContext(UserContext);
  return (
    <div data-testid="status-cell" className="status-cell">
      <div className="details">
        <div className={`status-${value}`}>
          <span className="dot" />
          {value === "booked" ? "attempted booking" : value}
        </div>
      </div>
      <div className="actions">
        <div className="action-icons">
          <div data-testid="default-icon-wrapper" className="block" aria-hidden>
            <span
              data-tip="View Booking details"
              className="icon"
              onClick={() =>
                history.push({
                  pathname: "/",
                  state: { token },
                })
              }
              aria-hidden
            >
              {/* <Eye size={24} color="#292B33" /> */}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

BookingStatusCell.propTypes = {
  value: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default BookingStatusCell;
